import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Observable, Subscription, map, startWith } from 'rxjs';
import {AirManagementService}  from 'src/app/services/air-management.service'
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { MatChipInputEvent } from '@angular/material/chips';
import {StaticdataService}  from 'src/app/services/staticdata.service'
import { DialogService } from 'src/app/util/dialog/dialog.service';

@Component({
  selector: 'app-meals',
  templateUrl: './meals.component.html',
  styleUrls: ['./meals.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class MealsComponent {
  action:any
  mealRegFg!:FormGroup
  showMealPopup:boolean=false
  mealData:any
  columnsMealsDisplay: string[] = ['carrier_code','source_id','type','meal_code','meal_desc'];
  expandedElement!: any | null;
  totalElements:any=0
  pageStr:any={
    number:'0',
    size:'10'
  }
  searchText:any=""

constructor(private DialogService:DialogService,private fb : FormBuilder,private AirManagementService:AirManagementService,private toastMsgService : ToastmsgService){
this.sourceCodelist()
this.carrierCodelist()
this.getMealList()
  this.dataFields()
}
  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    }
    return convertedValue;
  }
deleteData:any
  rowMealClick(element:any){
    this.action="update"
    this.showMealPopup=true
    this.deleteData=element
    this.mealRegFg=this.fb.group({
      "carrier_code" :  [element?.carrier_code,[Validators.required]],
      "source_id" : [element?.source_id.toString(),[Validators.required]],
      "meal_code":[element?.meal_code,[Validators.required]],
      "meal_desc":[element?.meal_desc,[Validators.required]],
      "dom_meal_price":[element?.dom_meal_price,[Validators.required]],
      'equipment_type':[element?.equipment_type,[Validators.required]],
      'int_meal_price': [element?.int_meal_price,[Validators.required]],
      'min_time_to_departure':[element?.min_time_to_departure,[Validators.required]],
      'type':[element?.type,[Validators.required]],
      'travel_type':[element?.travel_type,[Validators.required]],
      'meal_key':[element?.meal_key]
    });
  }


  closePopup(){
this.showMealPopup=false
this.dataFields()
  }
  dataFields(){
  
    this.mealRegFg=this.fb.group({
      "carrier_code" :  ['',[Validators.required]],
      "source_id" : ['',[Validators.required]],
      "meal_code":['',[Validators.required]],
      "meal_desc":['',[Validators.required]],
      "dom_meal_price":['',[Validators.required]],
      'equipment_type':['',[Validators.required]],
      'int_meal_price': ['',[Validators.required]],
      'min_time_to_departure':['',[Validators.required]],
      'type':['',[Validators.required]],
      'meal_key':[''],
      'travel_type':['D',[Validators.required]]
      

    });
  }

  
  AddMeal() {
    this.AirManagementService.saveMeal(this.mealRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Meal Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showMealPopup=false
           this.getMealList()

          } else {
            const body : any = res.body;
            this.registerMealErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerMealErrorMsg(err.status,err.error);
        }
      }
    )
  }

  deleteMeal(){




    this.DialogService.open({msg : 'Are you sure you want to delete the meal?',title : "Confirmation",buttonType : "YesNo"})
       
    this.DialogService.onResponse((response :  string) => {
     
      if(response=="Yes") {
    let request:any={
      carrier_code :  this.deleteData?.carrier_code,
      source_id : this.deleteData?.source_id,
      meal_code:this.deleteData?.meal_code,
      meal_desc:this.deleteData?.meal_desc,
      dom_meal_price:this.deleteData?.dom_meal_price,
      equipment_type:this.deleteData?.equipment_type,
      int_meal_price: this.deleteData?.int_meal_price,
      min_time_to_departure:this.deleteData?.min_time_to_departure,
      type:this.deleteData?.type

    }
    
    this.AirManagementService.deleteMeal(request)
    .subscribe({
      next : (res) => {
        if(res.status==200 || res.status==201) {
          this.toastMsgService.setMsg({msg : "Meal Deleted Successfully!",msgTitle : "Success", msgType : "I"});
         // this.router.navigate(["/sign-in"]);
         this.dataFields();
         this.showMealPopup=false
         this.getMealList()

        } else {
          const body : any = res.body;
          this.toastMsgService.setMsg({msg : "Failed to Delete Meal",msgTitle : "Warning", msgType : "W"});
        } 

      },error : (err) => {
        this.toastMsgService.setMsg({msg : "Failed to Delete Meal",msgTitle : "Warning", msgType : "W"});

      }
    }
  )}})
  }

  registerMealErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Meal",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save Meal",msgTitle:  "Warning", msgType : "W"});
    } 
  }

  nextPage(event:PageEvent) {
    
    let page:any = {};
    this.pageStr['number'] = event.pageIndex.toString();
    this.pageStr['size'] = event.pageSize.toString();
    this.getMealList()
  
  }

  searchFilter(){
    this.getMealList()
  }
  
  getMealList(){
   
    this.AirManagementService
    .getMealList(this.pageStr,this.searchText)
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.mealData=data['body']

       if(data.result.content.length>0){
        this.pageStr.number=data.result['number']
        this.pageStr.size=data.result['size']
      }
      this.totalElements = data.result['totalElements'];
      this.mealData=data.result['content']
       console.log(this.mealData)
        } else {
        
        } 
      },error : (err) => {
  
      }
    }
  )
  }
  

  carrierCodeList:any=[]
  sourceCodeList:any=[]
sourceCodelist(){

  this.AirManagementService
  .sourceCodelist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.sourceCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
carrierCodelist(){

  this.AirManagementService
  .carrierlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.carrierCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

onAddMeal(){
  this.action="new"

  this.showMealPopup=true
  this.dataFields()
}
onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}

sourceName(item:any){
  if(item){
   let code:any=[]
  //  console.log(this.sourceCodeList)
  //  console.log(item)
   code =this.sourceCodeList.filter((items:any)=>items.code===item.toString())
  //  console.log(code)
   if(code.length>0){
    return code[0].title}
    else{
return item
    }
  }else{
    return item
  }

}



myControl = new FormControl('');
options: string[] = ['One', 'Two', 'Three'];
filteredOptions!: Observable<any>;

ngOnInit() {
  
  this.filteredOptions = this.myControl.valueChanges.pipe(
    startWith(''),
    map((value:any) => this._filter(value || '')),
  );
}

private _filter(value: string): string[] {
  const filterValue = value.toLowerCase();

  return this.carrierCodeList.filter((option:any) =>  option.airlineDesignatorCode.toLowerCase().includes(filterValue)||option.carrierName.toLowerCase().includes(filterValue));
}
changeCarrier(){
  console.log(this.myControl)
  this.mealRegFg.value.carrier_code=this.myControl.value?.split(',')[1]

  this.mealRegFg=this.fb.group({
    "carrier_code" :  [this.mealRegFg.value?.carrier_code,[Validators.required]],
    "source_id" : [this.mealRegFg.value?.source_id.toString(),[Validators.required]],
    "meal_code":[this.mealRegFg.value?.meal_code,[Validators.required]],
    "meal_desc":[this.mealRegFg.value?.meal_desc,[Validators.required]],
    "dom_meal_price":[this.mealRegFg.value?.dom_meal_price,[Validators.required]],
    'equipment_type':[this.mealRegFg.value?.equipment_type,[Validators.required]],
    'int_meal_price': [this.mealRegFg.value?.int_meal_price,[Validators.required]],
    'min_time_to_departure':[this.mealRegFg.value?.min_time_to_departure,[Validators.required]],
    'type':[this.mealRegFg.value?.type,[Validators.required]],
    'travel_type':[this.mealRegFg.value?.travel_type,[Validators.required]],
    'meal_key':[this.mealRegFg.value?.meal_key]
  });
}
}
